/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEcommContentTemplate1ViewProps } from './ecomm-content-template-1';
import { imageAlignment } from './ecomm-content-template-1.props.autogenerated';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommContentTemplate1ViewProps>}
 */
export class EcommContentTemplate1View extends React.PureComponent<IEcommContentTemplate1ViewProps> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        let left;
        let right;

        if (config.imageAlignment === imageAlignment.left) {
            left = this._renderImage();
            right = this._renderInfo();
        } else {
            right = this._renderImage();
            left = this._renderInfo();
        }

        const resultStyle =
            config.className && config.className !== ''
                ? `row ecomm-content-template-1 ` + `${config.className}`
                : 'row ecomm-content-template-1';

        if (config.anchorID && config.anchorID !== '') {
            const style = `anchor ` + `${resultStyle}`;

            return (
                <div id={config.anchorID} className={style}>
                    {left}
                    {right}
                </div>
            );
        }

        return (
            <div className={resultStyle}>
                {left}
                {right}
            </div>
        );
    }

    private _renderImage(): JSX.Element | null {
        const { config } = this.props;

        const result =
            config.image && config.image.src ? (
                <img src={config.image.src} alt='' role='presentation' />
            ) : (
                <div className='msc-empty_image' />
            );

        return <div className='col-12 col-sm-6 img-container'>{result}</div>;
    }

    private _renderInfo(): JSX.Element | null {
        const { config, description } = this.props;

        let result = <h6>{config.title}</h6>;

        if (config.enablePrimaryColour) {
            result = <h6 className='enable-primary-colour'>{config.title}</h6>;
        }

        if (config.title === undefined) {
            return (
                <div className='col-12 col-sm-6 info-container'>
                    <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                        {description}
                    </p>
                </div>
            );
        }

        return (
            <div className='col-12 col-sm-6 info-container'>
                {result}
                <p id={this.props.id} {...this.props.renderModuleAttributes(this.props)}>
                    {description}
                </p>
            </div>
        );
    }
}

export default EcommContentTemplate1View;
